import { PageLayout, EmptyState } from '@deloitte-us-consulting/gp-sdk';

export default function NotFound() {
  return (
    <PageLayout title="Not found">
      <EmptyState title="Page not found" description="This route does not exist in the shell." />
    </PageLayout>
  );
}
